/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Chat = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 43 39" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M43 3v16.996a3 3 0 0 1-3 3h-5v6c0 .848-.506 1.495-1.17 1.8-.03.018-.054.041-.086.056a2.006 2.006 0 0 1-.753.148c-.008 0-.017-.005-.025-.005l-11.633-.003L11.2 38.597a1.967 1.967 0 0 1-1.19.402c-1.038 0-2.01-.818-2.01-2.003v-6.004H3a3 3 0 0 1-3-3V10.996a3 3 0 0 1 3-3h5V3a3.002 3.002 0 0 1 3-3.002h29c1.657 0 3 1.345 3 3.002zM29.666 28.996l-7.999-6H11a3 3 0 0 1-3-3v-10H3a1 1 0 0 0-1 1v16.995a1 1 0 0 0 1 1l7 .005v8l10.661-8zM41 3.001A1 1 0 0 0 40 2H11a1 1 0 0 0-1 1v16.996a1 1 0 0 0 1 1h11.334l10.665 8H33v-8h7a1 1 0 0 0 1-1z" /><path d="M23.99 17.012h2.016V19H23.99zm.87-1.609a.984.984 0 0 1-.993-.971v-1.441c0-.906.59-1.705 1.468-1.987l1.094-.358c.536-.175.896-.663.896-1.217v-.63c0-1.327-1.105-2.407-2.465-2.407-1.359 0-2.465 1.08-2.465 2.408 0 .535-.445.97-.993.97a.983.983 0 0 1-.994-.97c0-2.4 1.998-4.351 4.452-4.351 2.455 0 4.453 1.952 4.453 4.35v.63c0 1.39-.906 2.619-2.256 3.058l-1.093.356a.155.155 0 0 0-.11.148v1.44a.984.984 0 0 1-.994.972z" />
      </g>
    </svg>
  </span>
);

Chat.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Chat.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Chat;
